// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";

// const ContactForm = () => {
//   const location = useLocation();
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     company: "",
//     product: "",
//     message: "",
//   });

//   useEffect(() => {
//     if (location.state) {
//       setFormData((prev) => ({
//         ...prev,
//         product: location.state.productName || "",
//         message: location.state.message || "",
//       }));
//     }
//   }, [location.state]);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
    
//     // Here you would typically send the data to your server
//     alert(
//       "Thank you for your inquiry! We will get back to you within 24 hours."
//     );
//     setFormData({
//       name: "",
//       email: "",
//       phone: "",
//       company: "",
//       product: "",
//       message: "",
//     });
//   };

import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    product: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Replace with your own EmailJS credentials
    const serviceID = "service_rxx4d27";
    const templateID = "template_nb6o2r8";
    const publicKey = "bDbRXFzE7tZzSFjmt";

    emailjs.send(serviceID, templateID, formData, publicKey).then(
      (result) => {
        console.log("Email sent:", result.text);
        alert(
          "Thank you for your inquiry! We will get back to you within 24 hours."
        );
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          product: "",
          message: "",
        });
      },
      (error) => {
        console.error("Email sending error:", error.text);
        alert("There was an error sending your message. Please try again.");
      }
    );
  };

  return (
    <div className="contact-form">
      <h3 style={{ marginBottom: "20px"}}>Get In Touch</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Full Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone Number</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="company">Company Name</label>
          <input
            type="text"
            id="company"
            name="company"
            value={formData.company}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="product">Product Interest</label>
          <input
            type="text"
            id="product"
            name="product"
            value={formData.product}
            onChange={handleChange}
            placeholder="Which product are you interested in?"
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            rows="4"
            value={formData.message}
            onChange={handleChange}
            placeholder="Please provide details about your requirements..."
          />
        </div>
        <button type="submit" className="inquire-btn">
          Send Message
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
